import {
  ChangeDetectionStrategy,
  Component,
  OnInit,
}                                 from '@angular/core';
import { MaintenanceModeService } from './maintenance-mode.service';

@Component({
  selector: 'rb-maintenance-mode',
  templateUrl: './maintenance-mode.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class MaintenanceModeComponent implements OnInit {

  constructor(
    private readonly maintenanceModeService: MaintenanceModeService,
  ) {
  }

  ngOnInit() {
    this.maintenanceModeService.closeDialog();
  }
}
